import {AfterViewInit, Component, OnInit} from '@angular/core';
import {StepComponent} from "../../step/step.component";
import {StepService} from "../../services/step.service";
import {Router} from "@angular/router";
import {ElementService} from "../../services/element.service";
import {PortalService} from "../../services/portal.service";
import {PhotovoltaikcheckAnfrage} from "../anfrage/photovoltaikcheck.anfrage";
import {PhotovoltaikcheckConstants} from "../photovoltaikcheck.constants";
import {PhotovoltaikcheckRequestService} from "../services/request.service";

/**
 * Special component for the step to stop the advisor because we can not offer anything to the user
 */
@Component({
    selector: 'app-pvc-ausstieg',
    templateUrl: './eingabe.ausstieg.component.html',
    standalone: false
})
export class EingabeAusstiegComponent extends StepComponent implements OnInit, AfterViewInit {

  /**
   * The last step were we should navigate with the back button to.
   */
  lastStep: string = "../../einstieg";

  /**
   * define the case why we stop here.
   */
  case: string = null;

  /**
   * the anfrage object with the input of the user
   */
  anfrage: PhotovoltaikcheckAnfrage;

  /**
   * @inheritdoc
   */
  textkeyPrefix = PhotovoltaikcheckConstants.PHOTOVOLTAIKCHECK;

  startUrl: string;

  /**
   *
   * @param stepService
   * @param router
   * @param elementService
   * @param portalService
   * @param requestService
   */
  constructor(protected stepService: StepService, protected router: Router, protected elementService: ElementService, protected portalService: PortalService,
              protected requestService: PhotovoltaikcheckRequestService) {
    super(stepService, router, elementService);
  }

  /**
   * @inheritDoc
   */
  ngOnInit() {
    super.ngOnInit();

    this.anfrage = this.requestService.getAnfrage();

    this.startUrl = '/' + this.portalService.currentPortalId + '/' + PhotovoltaikcheckConstants.PHOTOVOLTAIKCHECK;

    // check if there is a last step given were we should navigate in case of the backstep to
    if(history?.state?.lastStep) {
      this.lastStep = history.state.lastStep;
    }

    this.case = 'todo';
    if (this.anfrage.interesse === PhotovoltaikcheckConstants.PATH_PVANLAGE &&
      this.anfrage.userInput?.nutzungstyp === PhotovoltaikcheckConstants.NUTZUNGSTYP_MIETER &&
      this.anfrage.userInput?.gebaeudetyp === PhotovoltaikcheckConstants.GEBAEUDETYP_MFH) {
      this.case = 'solar_mieter_mfh';
    }

    // no owner for small devices on multi apartement houses
    if (this.anfrage.interesse === PhotovoltaikcheckConstants.PATH_BALKONKRAFTWERK &&
      this.anfrage.userInput?.nutzungstyp === PhotovoltaikcheckConstants.NUTZUNGSTYP_HAUSEIGENTUEMER &&
    this.anfrage.userInput?.gebaeudetyp === PhotovoltaikcheckConstants.GEBAEUDETYP_MFH) {
      this.case = 'balkon_eigentuemer_mfh';
    }
  }

  /**
   * @inheritDoc
   */
  ngAfterViewInit(): void {
    super.ngAfterViewInit();

    // scroll to the top
    const element = document.querySelector("body");
    this.elementService.scrollToElement(element);
  }
}
